import { CartCountContextType } from "@/lib/main";
import { createContext } from "react";

const CartCountContext = createContext<CartCountContextType | null>(null);

export default CartCountContext;
